import { Menu, MenuItem as MuiMenuItem } from '@mui/material';
import { MenuSingleButton, StyledMenuListButton, StyledMoreVert, TableHeaderStyled, Title, } from './StylovyzeTable.styles';
import React from 'react';
import StylovyzeSearchBar from '../StylovyzeSearchBar';
const StylovyzeTableHeader = ({ title, search, menuItems, buttonStyle, titleArea, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const menuItemClose = (onClick) => () => {
        handleClose();
        onClick();
    };
    return (React.createElement(TableHeaderStyled, { justifyContent: "space-between", className: "StylovyzeTable--header", container: true },
        title && (React.createElement(Title, { variant: "h6", gutterBottom: true }, title)),
        search && (React.createElement(StylovyzeSearchBar, { onCancelSearch: search?.onCancelSearch, onChange: search?.onChange, onRequestSearch: search?.onRequestSearch, placeholder: search?.placeholder, value: search?.value, style: { width: '30%' }, searchInProgress: search?.searchInProgress, dataCy: search?.dataCy })),
        menuItems && menuItems.length === 1 && (React.createElement(MenuSingleButton, { onClick: menuItems[0].onClick, variant: buttonStyle?.variant, color: buttonStyle?.color, disabled: menuItems[0].disabled, "data-cy": menuItems[0].dataCy },
            menuItems[0].icon,
            menuItems[0].text)),
        menuItems && menuItems.length > 1 && (React.createElement(React.Fragment, null,
            React.createElement(StyledMenuListButton, { "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", onClick: handleClick },
                React.createElement(StyledMoreVert, null)),
            React.createElement(Menu, { anchorEl: anchorEl, open: !!anchorEl, onClose: handleClose }, menuItems.map((menuItem, i) => (React.createElement(MuiMenuItem, { key: i, onClick: menuItemClose(menuItem.onClick), "data-cy": menuItem.dataCy },
                menuItem.icon,
                menuItem.text)))))),
        menuItems == undefined && titleArea && React.createElement(React.Fragment, null, titleArea)));
};
export default StylovyzeTableHeader;
